import React from "react";
import { SanityRawContent } from "../../model/common";
import { splitByH2 } from "../../utils/blocks";
import ExpandableList from "../ExpandableList/ExpandableList";

interface CollapsibleSectionsProps {
  node: {
    content: SanityRawContent;
  };
}

const CollapsibleSections = ({
  node: { content }
}: CollapsibleSectionsProps) => (
  <ExpandableList sections={splitByH2(content || [])} />
);

export default CollapsibleSections;
